import type {Appareil, RamonagePhoto} from "@mytour/shared";
import {
  ReportPhotos,
  assertReportPhotosRendered,
  validateReportPhotos,
} from "../common/ReportPhotos";

const photoIdPrefix = "ramonage-photo-";
const missingPhotoMessage =
  "Une photo de l'attestation est absente ou illisible. Impossible de générer le PDF complet.";

export function validateRamonagePhotos(appareils: Appareil[]): void {
  for (const appareil of appareils) {
    validateReportPhotos(appareil.photos ?? [], missingPhotoMessage);
  }
}

export function assertRamonagePhotosRendered(result: unknown, expectedCount: number): void {
  assertReportPhotosRendered(result, expectedCount, photoIdPrefix, missingPhotoMessage);
}

export function RamonagePhotos({
  photos,
  appareilIndex,
}: {
  photos: RamonagePhoto[];
  appareilIndex: number;
}) {
  return <ReportPhotos photos={photos} photoIdPrefix={`${photoIdPrefix}${appareilIndex}-`} />;
}
